export default __webpack_public_path__ + "static/media/postdrawing.b2ae4822.mp4";